module.exports = __webpack_public_path__ + "media/assets/player/out-21ca912e9c8fd422519120895dc3943c.png";